import OrganizationService from "../../services/OrganizationService";
import { alertResponseError, alertResponseSuccess } from "../../helpers/general";
import { required, maxLength, integer } from 'vuelidate/lib/validators'
import { ERRORS_CODE } from "../../const/error_code";

export default {
    data() {
        return {
            organization: {
                name: '',
                name_kana: '',
                zip_code: '',
                address: '',
                tel: '',
                representative_name: '',
                responsible_dept: '',
                responsible_name: '',
                stripe_customer_id: ''
            },
            isUpdate: false,
            formAction: false,
            formSubmitted: false,
            errors: {},
        }
    },
    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        const loginUser = JSON.parse(localStorage.getItem('user'));
        if (loginUser.admin) {
            return this.getOrganization();
        } else {
            return alertResponseError(this.$t('organization.user_not_have_permission')).then((value) => {
                if (value) {
                    this.$router.push({ name: 'dashboard' });
                }
            });
        }
    },
    methods: {
        getOrganization() {
            OrganizationService.getDetailOrganization().then((response) => {
                if (response.data.success) {
                    this.isUpdate = true;
                    this.organization = response.data.data;
                }
            }).catch((error) => {
                if (!error.response || !error.response.data) {
                    alertResponseError(error);
                    return;
                }
                if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    return;
                }
                alertResponseError(error.response.data.errorCode);
            })
        },
        handleForm() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            // formAction = false => create
            if (this.formAction) {
                return 'edit'
            } else {
                return this.createOrganization();
            }
        },
        createOrganization() {
            OrganizationService.createOrganization(this.organization).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t('common_message.create_success'));
                    this.organization = {};
                    this.getOrganization();
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.VALIDATION_ERROR) {
                    return alertResponseError(this.$t('message_error.UNIQUE_INVOICE_MAIL'));
                } else if (!error.response || !error.response.data) {
                    alertResponseError(error);
                    return;
                }
                this.errors = error.response.data.msg;
                alertResponseError(error.response.data.errorCode);
            })
        },
    },
    computed: {
        nameErrorMsg() {
            if (!this.$v.organization.name.required) {
                return this.$t('message_error.ORGANIZATION_NAME_REQUIRED');
            }
            if (!this.$v.organization.name.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.name.$params.maxLength.max });
            }
            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        },
        nameKanaErrorMsg() {
            if (!this.$v.organization.name_kana.required) {
                return this.$t('common_errors.required', { field: this.$t('organization.furigana') });
            }
            if (!this.$v.organization.name_kana.isNameKana) {
                return this.$t('common_errors.invalid', { field: this.$t('organization.furigana') });
            }
            if (!this.$v.organization.name_kana.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.name_kana.$params.maxLength.max });
            }
            if (this.errors && this.errors.name_kana) {
                return this.errors.name_kana[0];
            }
            return null;
        },
        zipCodeErrorMsg() {
            if (!this.$v.organization.zip_code.required) {
                return this.$t('common_errors.required', { field: this.$t('organization.zip_code') });
            }
            if (!this.$v.organization.zip_code.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.zip_code.$params.maxLength.max });
            }
            if (!this.$v.organization.zip_code.isInvalid) {
                return this.$t('common_errors.invalid', { field: this.$t('organization.zip_code') });
            }
            return null;
        },
        addressErrorMsg() {
            if (!this.$v.organization.address.required) {
                return this.$t('common_errors.required', { field: this.$t('organization.organization_address') });
            }
            if (!this.$v.organization.address.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.address.$params.maxLength.max });
            }
            if (this.errors && this.errors.zip_code) {
                return this.errors.zip_code[0];
            }
            return null;
        },
        telErrorMsg() {
            if (!this.$v.organization.tel.required) {
                return this.$t('common_errors.required', { field: this.$t('common.phone_number') });
            }
            if (!this.$v.organization.tel.integer) {
                return this.$t('common_errors.integer');
            }
            if (!this.$v.organization.tel.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.tel.$params.maxLength.max });
            }
            if (this.errors && this.errors.tel) {
                return this.errors.tel[0];
            }
            return null;
        },
        representativeNameErrorMsg() {
            if (!this.$v.organization.representative_name.required) {
                return this.$t('common_errors.required', { field: this.$t('organization.representative') });
            }
            if (!this.$v.organization.representative_name.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.representative_name.$params.maxLength.max });
            }
            if (this.errors && this.errors.representative_name) {
                return this.errors.representative_name[0];
            }
            return null;
        },
        responsibleDeptErrorMsg() {
            if (!this.$v.organization.responsible_dept.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.responsible_dept.$params.maxLength.max });
            }
            if (this.errors && this.errors.responsible_dept) {
                return this.errors.responsible_dept[0];
            }
            return null;
        },
        responsibleNameErrorMsg() {
            if (!this.$v.organization.responsible_name.maxLength) {
                return this.$t('common_errors.max_lenght', { max: this.$v.organization.responsible_name.$params.maxLength.max });
            }
            if (this.errors && this.errors.responsible_name) {
                return this.errors.responsible_name[0];
            }
            return null;
        }
    },
    validations() {
        return {
            organization: {
                name: { required, maxLength: maxLength(32) },
                name_kana: {
                    required,
                    isNameKana(value) {
                        if (value) {
                            return /^([\u3040-\u30ff]*)$/.test(value);
                        }
                        return true;
                    },
                    maxLength: maxLength(64)
                },
                zip_code: {
                    required,
                    isInvalid(value) {
                        if (value) {
                            return /^(\d{3})-(\d{4})$/.test(value);
                        }
                        return true;
                    },
                    maxLength: maxLength(32)
                },
                address: { required, maxLength: maxLength(256) },
                tel: { required, integer, maxLength: maxLength(32) },
                representative_name: { required, maxLength: maxLength(32) },
                responsible_dept: { maxLength: maxLength(128) },
                responsible_name: { maxLength: maxLength(32) },
            }
        }
    },
}